<template>
  <header :style="{ top: `${currentTop}px` }">
    <div class="header total-width">
      <!--自己找张图片做10g0-->
      <router-link class="logo" to="index"
        ><img width="181"  src="../assets/images/index_logo.png" />
      </router-link>
      
      <nav>
        <router-link
          :to="item.link"
          active-class="actived"
          v-for="item in oList"
          :key="item.id"
          class="menu_item"
          @mouseover.native="selectHandle(item.id)"
          >{{ item.title }}</router-link
        >
        <a class="flex phone_wrap">
          <img src="../assets/images/index_phone.webp" alt="电话" />
          <p>400 6529 888</p>
        </a>
      </nav>
    </div>
  </header>
</template>
<script>
import { headerData } from '@/common/util/data.js'
export default {
  props: {
    top: {
      defalut: 0,
      type: Number,
    },
  },
  watch: {
    top(newVal, oldVal = 0) {
      this.currentTop = newVal > oldVal ? -85 : 0
    },
  },
  data() {
    return {
      ...headerData,
      currentData: [],
      // 当前滚动条的位置
      currentTop: 0,
    }
  },
  methods: {
    selectHandle(id) {
      this.currentData = this.hList.find((item) => item.id === id).list
    },
    elHandle() {
      this.currentData = []
    },
  },
}
</script>
<style lang="less" scoped>
header {
  width: 100%;
  height: 80px;
  line-height: 80px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  background: rgba(0, 0, 0, 0.42);
  backdrop-filter: blur(5px);
  transition: all 0.3s linear;
  .header {
    position: relative;
    z-index: 999;
    display: flex;
    margin: 0 auto;
    justify-content: space-between;
    .logo {
      display: flex;
      align-items: center;
      width: 181px;
      height: 80px;
    }
    nav {
      display: flex;
      height: 80px;
      width: 80%;
      justify-content: space-between;
    }
    nav .menu_item,
    nav .menu_item:visited {
      display: inline-block;
      text-align: center;
      color: #ffffff;
      font-size: 16px;
      line-height: 80px;
    }
  }
  .wrap {
    background: #fff;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.06);
  }
}
.phone_wrap {
  display: flex;
  align-items: center;
  height: 80px;
  img {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }
  p {
    height: auto;
    display: inline-block;
    color: #fff;
    font-weight: bold;
  }
}
</style>
